import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import { FormControlLabel, Checkbox } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import scan from "../../assets/images/scan.png";
import Button from "@mui/material/Button";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import getCookie, { setTeacherCookie, teacherState } from "../../Atom";
import CircularProgress from "@mui/material/CircularProgress";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import file from "../../assets/images/file.png";
import "./ScanDevice.css";
import EditFile from "../launchtrakflights/EditFile/EditFile";
import DialogTitle from "@mui/material/DialogTitle";
import { createNewLaunchTrek, getAllClassbyTeacher } from '../launchtrakflights/api';
import DeleteFiles from "../launchtrakflights/DeleteFile/DeleteFiles";
export default function ScanDevice(props) {
  // const [open, setOpen] = React.useState(false);
  const [openStyleBtn, setOpenStyleBtn] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [selectedDevice, setSelectedDevice] = React.useState("");
  const [openDelete, setOpenDelete] = React.useState(false);
  const [fileName, setFileName] = React.useState("");
  const [index, setIndex] = React.useState(0);
 
  const [expanded, setExpanded] = React.useState('panel1');
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    // border: `1px solid ${theme.palette.divider}`,
    // '&:not(:last-child)': {
    //     borderBottom: 0,
    // },
    // '&::before': {
    //     display: 'none',
    // },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));
  const onCheckFiles = (item, index) => {
    const itemIndex = props?.checkedFiles.indexOf(item);
    let temp = [...props?.checkedFiles];
    let tempArr = [...props?.tempArray];
    if (itemIndex >= 0) {
      temp.splice(itemIndex, 1);
      tempArr.splice(itemIndex, 1);
      props?.setCheckedFiles(temp);
      props?.setTempArray(tempArr);
    } else {
      temp[index] = item;
      tempArr.push(item);
      props?.setCheckedFiles(temp);
      props?.setTempArray(tempArr);
    }
  };
  const onCheckAllFiles = () => {
    if (props?.tempArray?.length === props?.fileNames?.length) {
      props?.setCheckedFiles([]);
      props?.setTempArray([]);
    } else {
      props?.setCheckedFiles(props?.fileNames);
      props?.setTempArray(props?.fileNames);
    }
  };
  const ondeleteAll = () => {
    setOpenDelete(true)
  };
  // const onremoveFile = (item) => {
  //   const itemIndex = checkedFiles.indexOf(item);
  //   let temp = [...checkedFiles];
  //   if (itemIndex >= 0) {
  //     temp.splice(itemIndex, 1);
  //     setCheckedFiles(temp);
  //   }
  //   if (checkedFiles?.length > 0) {

  //   }
  // };
  const onEditFile = (item, index) => {
    setFileName(item);
    setIndex(index);
    props?.setMetaData({
      name: props?.metaArr[index]?.name || item,
      pressure: props?.metaArr[index]?.pressure,
      volumeOfWater: props?.metaArr[index]?.volumeOfWater,
      volumeOfEngine: props?.metaArr[index]?.volumeOfEngine,
      nozzleSize: props?.metaArr[index]?.nozzleSize,
      rocketDryMass: props?.metaArr[index]?.rocketDryMass,
      parachuteSize: props?.metaArr[index]?.parachuteSize,
      noParachut: props?.metaArr[index]?.noParachut,
    })
    setOpenEdit(true);
  };
  const onClickScan = async() => {
    props?.setScanLoading(true);
    props?.getFilenames();
    await props?.delay(3000)
    if(!props?.fileNames?.length){  props?.setNoFiles(true);}
    props?.setScanLoading(false);
  };

  const handleClose = () => {
    props?.disconnectFromSerial()
    props?.setCheckedFiles([]);
    props?.setOpen(false);
    props?.setMetaArr([])
    props?.setTempArray([])
    props?.setNoFiles(false);
    props?.setScanLoading(false);
    props?.setFileNames([])
    props?.setallclasses([])
    props?.setSelectedClassIds([])
    props?.setSelectedClassNames([]);
    props?.setDeviceData([
      {
        name: "",
        pressure: 0,
        volumeOfWater: 0,
        volumeOfEngine: 0,
        nozzleSize: 0,
        rocketDryMass: 0,
        parachuteSize: 0,
        noParachut: false,
        decentSpeed: 0,
        topSpeed: 0,
        totalFlightTime: 0,
        apogeeAltitude: 0,
        apogeeTime: 0,
        coastTime: 0,
      },
    ])
  };
  const onClassSelect = (value) => {
    // const value = event.target.value;
    const itemIndex = props?.selectedClassIds.indexOf(value?._id);
    let temp = [...props?.selectedClassIds];
    let tempName = [...props?.selectedClassNames];
    if (itemIndex >= 0) {
      temp.splice(itemIndex, 1)
      tempName.splice(itemIndex, 1)
  } else {
    temp = [...props?.selectedClassIds, value._id];
    tempName = [...props?.selectedClassNames, value.name];
  }
  props?.setSelectedClassIds(temp);
      props?.setSelectedClassNames(tempName);
    // if (itemIndex < 0) {
    //   temp.push(value?._id);
    //   tempName.push(value.name);
    //   props?.setSelectedClassIds(temp);
    //   props?.setSelectedClassNames(tempName);
    // }
  };

  const filterPressureSpike = async (data) => {
    let graphData = [...data];
    if (!graphData || graphData === 0) return [];

    //If the first pressure value is greater than 1,000,000 then replace with second pressure value.
    if (
      graphData.length > 1 &&
      graphData[0].press !== undefined &&
      graphData[0].press >= 1000000 &&
      graphData[1] &&
      graphData[1].press !== undefined
    ) {
      graphData[0].press = graphData[1].press;
    }

    // If current pressure is greater than 10 X previous pressure then replace current with previous.
    for (let i = 1; i < graphData.length; i++) {
      if (
        graphData[i].press !== undefined &&
        graphData[i - 1].press !== undefined &&
        graphData[i].press >= graphData[i - 1].press * 10
      ) {
        graphData[i].press = graphData[i - 1].press;
      }
    }
    return graphData;
  };

  const uploadFiles = async () => {
    setLoading(true);
    let newData = [];
    for (let index = 0; index < props?.checkedFiles?.length; index++) {
      const element = props?.checkedFiles[index];
      if (element) {
        localStorage.setItem("filename", element);
        const data = await props?.viewFileData();

          //pressure spike check
          let filterdata = [];
          if (data.graphData.length > 0) {
            filterdata = await filterPressureSpike(data.graphData);
          }

        newData.push({
          metaData: { ...props?.metaArr[index] },
          originalName: element,
          valuesOfInterest:data?.valuesOfInterest,
          classes: [...props?.selectedClassIds],
          graphData: filterdata,
        })
      }
    }
    props?.setDeviceData(newData);
    const _cookie = getCookie('recoil-persist')
    if (_cookie) {
      const user = _cookie ? JSON.parse(_cookie)['teacher_v1'] : {}
      const launchRes = await createNewLaunchTrek(newData, user.token);
      if (launchRes.res.status === 200) {
        await props?.delay(1000);
        handleClose();
        props?.getLaunchData(user, props?.page, props?.pageLimit,'createdAt','desc');
        setLoading(false);
        props?.setSnackBarShow(true);
        props?.setSnackBarMessage("Files uploaded successfully");
        props?.setSnackBarSeverity("success");
        props?.setallclasses([])
      }
    }
  };
  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setTeacherCookie({
        fName: null,
        userId: null,
        token: null,
        lName: null,
      })
      let hostname = window.location.host;
      window.location.assign(`${window.location.protocol}//${hostname}/teachers`)
    })
  }

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={props?.open}
      // onClose={handleClose}
      >
        <DialogTitle></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading || props?.scanLoading}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <Box
            noValidate
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              m: "auto",
              width: "fit-content",
              position: "relative",
            }}
          >
            <div
              className={loading ? "blur-content" : "teacher-parent-container"}
              style={{ width: "100%" }}
            >
              <div className="teacher-parent-files-container" >
                <Box
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontSize: 21.51,
                    textAlign: "left !important",
                    width: "100%",
                  }}
                >
                  {props?.fileNames?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        alignContent: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FormControlLabel
                        disabled={loading}
                        control={
                          <Checkbox
                            checked={props?.tempArray?.length === props?.fileNames?.length ? true : false}
                            // onClick={editFeatured}
                            onClick={onCheckAllFiles}
                            style={{
                              color: "#0000004D",
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="subtitle1"
                            className="text-[#00000033]"
                            sx={{
                              fontWeight: 400,
                              fontSize: 19,
                              fontFamily: "Inter",
                            }}
                          >
                            Select all
                          </Typography>
                        }
                      />
                      <IconButton onClick={ondeleteAll} disabled={loading}>
                        <DeleteOutlineIcon
                          sx={{ color: "#E80000", cursor: "pointer", pointerEvents: loading ? "none" : "auto" }}
                        />
                      </IconButton>
                    </div>
                  )}
                </Box>
                <div
                  className="teacher-files-container"
                  style={{
                    backgroundColor: "#F7E5FC",
                    height: "517px",
                    overflowY: 'auto',
                    padding: '20px',
                    borderRadius: "16px 16px 16px 16px",
                    display: "flex",
                    justifyContent: props?.fileNames?.length <= 0 && "center",
                  }}
                >
                 {
              props?.noFiles && props?.fileNames?.length <= 0 ? <Typography className="align-self-center">There are no files on the device.</Typography>
              :props?.fileNames?.length > 0 ?
                    <div style={{ width: '100%' }}>
                      {props?.fileNames?.map((item, index) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              width: '100%'
                            }}
                          >
                            <div>
                              <FormControlLabel
                                disabled={loading}
                                control={
                                  <Checkbox
                                    checked={ props?.checkedFiles?.includes(item) ? true : false}
                                    // onClick={() => loadData(item)}
                                    onClick={() => onCheckFiles(item, index)}
                                    style={{
                                      color: "#0000004D",
                                    }}
                                  />
                                }
                                label={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: 5,
                                    }}
                                  >
                                    <img
                                      src={file}
                                      alt="file"
                                      style={{ width: "22.77px" }}
                                    />
                                    <Typography
                                      variant="subtitle1"
                                      className="text-[#00000033]"
                                      sx={{
                                        fontWeight: 400,
                                        fontSize: 19,
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {item}
                                    </Typography>
                                  </Box>
                                }
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "3px",
                              }}
                            >
                              <EditIcon
                                sx={{
                                  color: props?.checkedFiles.includes(item)
                                    ? "#000000B0"
                                    : "gray",
                                  cursor: props?.checkedFiles.includes(item)
                                    ? "pointer"
                                    : "not-allowed",
                                  pointerEvents: loading ? 'none' : 'auto'
                                }}
                                onClick={() => {
                                  if (props?.checkedFiles.includes(item)) {
                                    onEditFile(item, index);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    : <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        gap: 40,
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <img
                          src={file}
                          style={{ width: "100px", height: "104px" }}
                          alt="file"
                        />
                      </div>
                      <Button
                        component="label"
                        variant="contained"
                        disabled={loading || props?.scanLoading}
                        sx={{
                          backgroundColor: "#348BE3",
                          width: 165,
                          height: 53,
                          textTransform: "none",
                          display: "flex",
                          flexDirection: "row !important",
                          alignItems: "center !important",
                          alignContent: "center",
                          justifyContent: "center",
                          justifyItems: "center",

                        }}
                        startIcon={
                          <img
                            src={scan}
                            style={{ width: 23, height: 23 }}
                            alt="file"
                          />
                        }
                        // onClick={() => props?.getFilenames()}
                        onClick={onClickScan}
                      >
                        Scan Device
                      </Button>
                    </div>}
                </div>
              </div>
              
              <div className="device-container">
                {/* <Button onClick={viewFileData}>Load Data From File</Button> */}
                {/* //SECTION FOR  Assign to District */}
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 15 }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,

                    }}
                  >
                    <Typography style={{
                      color: "#000000",
                      fontWeight: 500,
                      fontSize: 24,
                      fontFamily: "Inter",
                    }}>
                      Your LaunchTrak has been connected successfully!
                    </Typography>
                    <div style={{
                      marginTop: 15, display: "flex",
                      flexDirection: "column",
                      gap: 10
                    }}>
                        <Typography
                            variant="subtitle1"
                            className="text-[#00000033]"
                            sx={{
                              fontWeight: 400,
                              fontSize: 19,
                              fontFamily: "Inter",
                            }}
                          >
                            Assign to Classes
                          </Typography>
                          <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                            {/* <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                Select Classes
                                            </AccordionSummary> */}
                                            <AccordionDetails sx={{padding:0}}>
                                            {props?.allClasses?.map((item) => (
                                                 
                                                    <div style={{display:'flex', alignItems:'center', cursor:'pointer'}}
                                                        key={item?._id}
                                                         onClick={()=>onClassSelect(item)}
                                                    >
                                                        <Checkbox
                                                             checked={props?.selectedClassIds?.indexOf(item?._id) > -1} /> 
                                                        <Typography variant='body2'>{item?.name}</Typography>
                                                    </div>
                                            ))}
                                            </AccordionDetails>

                                        </Accordion>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
          {loading && (
            <Box
              display="flex"
              flexDirection='column'
              gap={3}
              justifyContent="center"
              alignItems="center"
              className="loading-overlay"
            >
              <Typography> Saving the files, this may take a while</Typography>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            component="label"
            variant="contained"
            disabled={props?.checkedFiles?.length && !loading ? false : true}
            sx={{
              backgroundColor: "#1A273B",
              width: 223,
              height: 55,
              textTransform: "none",
              display: "flex",
              flexDirection: "row !important",
              alignItems: "center !important",
              alignContent: "center",
              justifyContent: "center",
              justifyItems: "center",
            }}
            startIcon={<FileUploadOutlinedIcon />}
            onClick={uploadFiles}
          >
            Upload & Assign
          </Button>
        </DialogActions>
      </Dialog>
      <EditFile
        fileName={fileName}
        deviceData={props?.deviceData}
        setDeviceData={props?.setDeviceData}
        index={index}
        metaArr={props?.metaArr}
        setMetaArr={props?.setMetaArr}
        open={openEdit}
        setOpen={setOpenEdit}
        setSnackBarShow={props?.setSnackBarShow}
        setSnackBarMessage={props?.setSnackBarMessage}
        setSnackBarSeverity={props?.setSnackBarSeverity}
        metaData={props?.metaData}
        setMetaData={props?.setMetaData}
        setSelectedClassIds={props?.setSelectedClassIds}
        setSelectedClassNames={props?.setSelectedClassNames}
      />
      <DeleteFiles
        open={openDelete}
        setOpen={setOpenDelete}
        moduleDel="deleteFromDevice"
        setCheckedFiles={props?.setCheckedFiles}
        handleClose={handleClose}
        setSnackBarShow={props?.setSnackBarShow}
        setSnackBarMessage={props?.setSnackBarMessage}
        setSnackBarSeverity={props?.setSnackBarSeverity}
        deleteFilesFromDevice={props?.deleteFilesFromDevice}
      />
    </React.Fragment>
  );
}
